/**
 * `<DemoPhoneWarmup/>` - loads the demo phone's frame early (#2824).
 *
 * Mounted once in the app shell for a guided demo, so the phone is warm on
 * Home, People and Setup too, not only on the roster page. It points the
 * hidden frame at the person the picked scenario is about. The roster page's
 * dock then reveals the same frame. Renders nothing.
 */
import { useEffect } from "react";

import { useDemoSessionState } from "../../api/useDemoSessionState";
import { suggestionFor } from "../../lib/demoPhone";
import { isGuidedDemo } from "../../lib/demoSession";
import { phoneFrameSrc } from "./DemoPhoneView";
import { setPhoneFrameSrc } from "./phoneFramePool";

export function DemoPhoneWarmup() {
  if (!isGuidedDemo()) return null;
  return <Warm />;
}

function Warm() {
  const session = useDemoSessionState();
  const data = session.data;
  const person = data?.changes.find((c) => c.id === data.variant)?.member_id ?? null;
  const src = person ? phoneFrameSrc(person, suggestionFor(data, person), false) : null;
  useEffect(() => {
    if (src) setPhoneFrameSrc(src);
  }, [src]);
  return null;
}
